import { useFormatMessage } from '@/hooks';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import { createPoi, fetchPois, modifyPoi } from 'state/actions/pois';
import './Poi.css';
import ProductForm from 'components/ProductForm';
import {
  createProduct,
  getProductsById,
  modifyProduct,
} from 'state/actions/product';

const Product = ({ history }) => {
  const { id, siteId, productId } = useParams();

  const { success, poisList, poiData, sitesList, error, productData } =
    useSelector(
      (state) => ({
        success: state.pois.success,
        poisList: state.pois.list,
        poiData: state.pois.poi,
        sitesList: state.sites.list,
        error: state.pois.error,
        productData: state.products.product,
      }),
      shallowEqual
    );

  const [product, setProduct] = useState(productData || {});

  const dispatch = useDispatch();

  useEffect(() => {
    if (productId) {
      dispatch(getProductsById({ siteId, productId }));
    }
  }, [productId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (productData) {
      setProduct(productData);
    }
  }, [productData]); // eslint-disable-line react-hooks/exhaustive-deps

  const isEditing = !!productId;

  const productForm =
    !productData && id ? (
      <ClipLoader />
    ) : (
      <ProductForm
        isEditing={isEditing}
        product={product}
        sites={sitesList}
        setProduct={setProduct}
        success={success}
        id={productId}
        history={history}
        error={error}
      />
    );

  // const redirect = (error || success) && <Redirect to={paths.USERS} />;

  return (
    <div className="media">
      <div className="media-header">
        <h1>{isEditing ? 'Edit Product' : 'Add New Product'}</h1>
        <div onClick={() => history.goBack()} className="button-secondary">
          <i className="feather-arrow-left" />
          Back
        </div>
      </div>
      <div className="media-content">{productForm}</div>
    </div>
  );
};

export default Product;
